/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "Bolt",
  size: 20
}

const SvgBolt = ({ size, ...props }: Props) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <path d="M4.74 20l2.99-8H3L15.43 1l-3.11 8h4.7L4.74 20zm4.44-9L7.1 16.39 14.47 10h-3.61l2.13-5.33L5.61 11h3.57z" />
  </Svg>
)

SvgBolt.defaultProps = defaultProps
export default SvgBolt
